import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/nb';

import api from 'api';
import css from 'css';
import Container from 'partials/Container';
import Image from 'partials/Image';
import Loader from 'partials/Loader';
import { H1, H3 } from 'partials/typography';
import { Input, Button } from 'partials/formElements';
import { parseQueryString, msg } from 'helpers';

import {
    setBookingVisibility,
    setBookingProgressCollapsedValue,
    setCartCollapsedValue,
    setBookingReference,
    setBookingMeetingType,
    setBookingTimeSlot,
    setBookingContactDetails,
    setBookingFiles,
    setBookingStep,
    resetBookingState,
    setEditedBookingTimeSlotBackup,
} from 'store';

class EditBooking extends Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            mobile: '',
            code: '',
            codeFormEnabled: false,
            actionFormenabled: false,
            working: false,
            error: '',
            booking: null,
        }
    }

    componentDidMount() {
        this.mounted = true;

        const queryVars = parseQueryString(this.props.location.search);
        if(queryVars && queryVars.code) {
            this.setState({ code: queryVars.code });
        }
    }

    componnetWillunmount() {
        this.mounted = false;

        this.props.resetBookingState();
    }

    _getBookingByCode() {
        const { code } = this.state;

        if(!code || (code.length < 6 || code.length > 8)) {
            alert(msg('provideCode'));
            return;
        }

        this.setState({ working: true, error: '' });

        api.getBooking({ reference: code })
            .then(resp => {
                console.log('get booking response:', resp.data);
                if(this.mounted && resp.data) {

                    if(!resp.data.error && resp.data[0]) {
                        // shwo "select action" UI
                        this.setState({ 
                            actionFormenabled: true, 
                            working: false,
                            booking: resp.data[0]
                        });
                    } else {
                        console.warn('"success" key was not fonund in response form 4D to "/get" request');
                        this.setState({ 
                            working: false,                         
                            error: msg('noBookingForCode'),
                        });
                    }

                }
            })
            .catch(e => console.log(e));
    }

    _requestCode() {
        const { mobile } = this.state;

        if(!mobile) {
            alert(msg('providePhone'));
            return;
        }

        this.setState({ working: true, error: '' });

        if(process.env.NODE_ENV === 'development' || mobile === '+48665001225') {
            this.setState({ 
                working: false,                         
                codeFormEnabled: true,
                mobile: '',
            });
            return;
        }

        api.requestBookingCode({ mobile })
            .then(resp => {
                console.log('Request code response:', resp.data);
                if(this.mounted && resp.data) {

                    if(resp.data.success) {
                        this.setState({ 
                            working: false,                         
                            codeFormEnabled: true,
                            mobile: '',
                        });
                    } else {
                        console.warn('"success" key was not fonund in response form 4D to "/send-ref" request');
                        this.setState({ 
                            working: false,                         
                            error: msg('smsError'),
                        });
                    }
                }
            })
            .catch(e => console.log(e));
    }

    _editBooking() {
        const { code, booking } = this.state;
        const { setBookingVisibility, 
                setBookingProgressCollapsedValue, 
                setCartCollapsedValue, 
                setBookingReference,
                setBookingMeetingType,
                setBookingTimeSlot,
                setBookingContactDetails,
                setBookingFiles,
                setBookingStep,
                setEditedBookingTimeSlotBackup,
            } = this.props;

        // populate booking data
        setBookingMeetingType(booking.Møte_Type);

        {
            const slotStartMoment = moment
                .parseZone(booking.Dato)
                .hour(Number(booking.Klokken.substring(0,2)))
                .minute(Number(booking.Klokken.substring(3,5)));
            const slotEndMoment = slotStartMoment.clone().add(30, 'minutes');

            setBookingTimeSlot({
                id: booking.Booking_ID,
                start: slotStartMoment,
                end: slotEndMoment,
                _date: slotStartMoment.format('DD-MM-YYYY'),
                _startTime: slotStartMoment.format('HH:mm'),
                _endTime: slotEndMoment.format('HH:mm')
            });

            setEditedBookingTimeSlotBackup({
                Dato: booking.Dato,
                Klokken: booking.Klokken,
                Booking_ID: booking.Booking_ID,
                _week: slotStartMoment.format('w'),
                _backup: true,
            });
        }

        setBookingContactDetails({
            firstName: booking.Fornavn,
            lastName: booking.Etternavn,
            phone: '',
            email: '',
        });

        setBookingFiles([]);
        setBookingReference(code);

        // show booking form
        setBookingStep(5);
        setBookingVisibility(true);
        setBookingProgressCollapsedValue(false);
        setCartCollapsedValue(true);

        this.setState({
            mobile: '',
            code: '',
            codeFormEnabled: false,
            actionFormenabled: false,
            working: false,
            error: '',
            booking: null,
        });
    }

    _deleteBooking() {
        const { code } = this.state;

        this.setState({ working: true, error: '' });

        api.deleteBooking({ reference: code })
            .then(resp => {
                console.log('Delete booking response:', resp.data);
                if(this.mounted && resp.data) {
                    if(resp.data.success) {
                        this.setState({ 
                            mobile: '',
                            code: '',
                            codeFormEnabled: false,
                            actionFormenabled: false,
                            working: false,
                            error: '',
                            booking: null,
                        });
                        alert(msg('bookingCanceled'));
                    } else {
                        console.warn('"success" key was not fonund in response form 4D to "/delete" request');
                        this.setState({ working: false });
                        alert(msg('cancelBookingError'));
                    }
                }
            })
            .catch(e => console.log(e));

    }
  
    render() {
        const { data } = this.props;
        const { mobile, code, codeFormEnabled, working, error, actionFormenabled, booking } = this.state;

        return (
            <ModuleWrapper>
                <Background>
                    {data.background_image &&<Image background image={data.background_image} />}
                </Background>
                <Container flex wrap>
                    <Main>

                        {!codeFormEnabled && !actionFormenabled &&
                            <div>
                                <H1>Endre time</H1>
                                <H3>Skriv inn telefonnummeret ditt, så sender vi deg en kode, slik du trygt kan endre dine valg</H3>
                                <div>
                                    <Input value={mobile} error={error} onChange={e => this.setState({ mobile: e.target.value })} label="Telefonnummer"/>
                                </div>
                                {!working && <Button onClick={this._requestCode.bind(this)} red >Neste</Button>}
                                {working && <Loader color="#fff"/>}
                            </div>
                        }

                        {codeFormEnabled && !actionFormenabled &&
                            <div>
                                <H1>Endre time</H1>
                                <H3>Skriv inn koden du har mottatt på SMS</H3>
                                <div>
                                    <Input value={code} error={error} onChange={e => this.setState({ code: e.target.value.substring(0, 8).trim() })} label="Kode (6-8 siffer)"/>
                                </div>
                                {!working && <Button onClick={this._getBookingByCode.bind(this)} red >Neste</Button>}
                                {working && <Loader color="#fff"/>}
                                {!working && <p>Ingen kode? <a onClick={() => this.setState({ codeFormEnabled: false, error: '' })}>Send på nytt</a></p>}
                            </div>
                        }

                        {actionFormenabled && 
                            <div className="action-type">
                                <H1>Endre time</H1>
                                <H3>
                                    {booking && `${booking.Fornavn} ${booking.Etternavn}`}
                                    {booking && <br/>}
                                    {booking && `${booking.Møte_Type} ${moment.parseZone(booking.Dato).format('D. MMMM')} ${booking.Klokken}`}
                                </H3>
                                {!working && 
                                    <div>
                                        {!working && <Button onClick={this._editBooking.bind(this)} red >Edit booking</Button>}
                                        {!working && <Button onClick={this._deleteBooking.bind(this)} red outline >Delete booking</Button>}
                                    </div>
                                }
                                {working && <Loader color="#fff"/>}
                            </div>
                        }

                    </Main>
                </Container>
            </ModuleWrapper>
        );
    }
}

const mapStateToProps = state => ({

});

const actions = {
    setBookingVisibility,
    setBookingProgressCollapsedValue,
    setCartCollapsedValue,
    setBookingReference,
    setBookingMeetingType,
    setBookingTimeSlot,
    setBookingContactDetails,
    setBookingFiles,
    setBookingStep,
    resetBookingState,
    setEditedBookingTimeSlotBackup,
}

export default withRouter(connect(mapStateToProps, actions)(EditBooking));

const ModuleWrapper = styled.div`
    position:relative;
    background: ${css.colors.main};
    color:#fff;
    margin-top: -130px;
    min-height:100vh;

    @media(max-width: 767px) {
        min-height: auto;
    }

    > .container {
        min-height:100vh;
        @media(max-width: 767px) {
            min-height:auto;
        }
    }
`

const Main = styled.div`
    width: 50%;
    display: flex;
    flex-direction:column;
    padding: 130px 0;
    justify-content:center;

    @media(max-width: 767px) {
        width:100%;
        padding: 50px 0;
        text-align:center;
    }

    > div {
        padding-right:100px;
        @media(max-width: 767px) {
            padding-right:0;
        }
        h1 {
            margin-bottom: 10px;
        }
        h3 {
            margin-bottom: 40px;
            @media(max-width: 767px) {
                padding: 0 30px;
            }
        }
        .input-wrapper {
            margin-bottom:40px;
            text-align: left;
            @media(max-width: 767px) {
                display: inline-block;
            }
            input {
                background: #E7F1FD;
                border-bottom: 2px solid ${css.colors.blue};
                width: 260px;
            }
            &.error {
                input {
                    border-bottom: 2px solid ${css.colors.red};
                }
            }
        }
        button {
            margin-bottom: 16px;
            &:hover {
                color: ${css.colors.red};
            }
        }
        .loader {
            height: 45px;
            margin-bottom: 12px;
            div {
                top:18px;
            }
        }
        p {
            a {
                text-decoration: underline;
                cursor: pointer;
            }
        }

        &.action-type {
            > div {
                button {
                    &:first-child {
                        margin-right:40px;
                    }
                    &:last-child {
                        color: ${css.colors.red};
                        &:hover {
                            color: ${css.colors.main};
                        }
                    }
                }
            }
        }
    }
`

const Background = styled.div`
    width: 50%;
    display: flex;
    position:absolute;
    top:0;
    right:0;
    height:100%;

    @media(max-width: 767px) {
        position:relative;
        height:380px;
        width:100%;
        div {
            padding:0;
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/BookMeeting/EditBooking.js